module.exports = __webpack_public_path__ + "img/green-scratch.5f756ea5.png";